/*
 * Action Types
 */
export enum AppBarTypes {
  SET_APPBAR_VISIBLE = '@appbar/SET_APPBAR_VISIBLE',
}

/*
 * State type
 */
export interface AppBarState {
  readonly visible: boolean;
}
